import { NotFoundView } from 'common/components/NotFound';
import { RoleType } from 'common/models';
import { PrivateRoute } from 'features/auth/components/privateRoute.tsx';
import { UserRoutes } from 'features/user-views/Routes';
import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Constants } from 'utils/constants';
import SettingsView from './SettingsView';
import { ContractorsView } from './components/Sub-views/ContractorsView/ContractorsView';
import { RatesView } from './components/Sub-views/RatesView/RatesView';
import { SeasonsView } from './components/Sub-views/SeasonsView/SeasonsView';
import { SpokaneSync } from './components/Sub-views/SpokaneSyncView/SpokaneSync';
import { VarietiesView } from './components/Sub-views/VarietiesView/VarietiesView';

export const SettingsRoutes: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        exact
        path={path}
        component={SettingsView}
        requiredRoles={[RoleType.Admin]}
      />
      <PrivateRoute
        exact
        path={`${path}${Constants.routes.SYNC}`}
        component={SpokaneSync}
        requiredRoles={[RoleType.Admin]}
      />
      <PrivateRoute
        exact
        path={`${path}${Constants.routes.SEASON_SETTINGS}`}
        component={SeasonsView}
        requiredRoles={[RoleType.Admin]}
      />
      <PrivateRoute
        path={`${path}${Constants.routes.VARIETY_SETTINGS}`}
        component={VarietiesView}
        requiredRoles={[RoleType.Admin]}
      />
      <PrivateRoute
        path={`${path}${Constants.routes.RATE_SETTINGS}`}
        component={RatesView}
        requiredRoles={[RoleType.Admin]}
      />
      <PrivateRoute
        exact
        path={`${path}${Constants.routes.CONTRACTOR_SETTINGS}`}
        component={ContractorsView}
        requiredRoles={[RoleType.Admin]}
      />
      <PrivateRoute
        path={`${path}${Constants.routes.USERS_LIST}`}
        component={UserRoutes}
        requiredRoles={[RoleType.Admin]}
      />
      <Route component={NotFoundView} />
    </Switch>
  );
};
